import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material';
import { MENU_PROPS } from '../../../config/constants';

export function CustomSelect({ label, value, valueChanged, values, width, disabled, multiple }) {
  function handleChange(event) {
    let {
      target: { value },
    } = event;
    valueChanged(value);
  }

  function renderValue(selected) {
    const caption = multiple ? getCaptionsForMultiple(selected) : getCaption(selected);
    return multiple ? caption.join(', ') : caption;
  }

  function getCaption(selected) {
    const caption = values.find((item) => item.value === selected);
    return caption?.name;
  }

  function getCaptionsForMultiple(selected) {
    const captions = values.filter((item) => selected.indexOf(item.value) > -1);
    return captions.map((item) => item.name);
  }

  return (
    <FormControl disabled={disabled} sx={{ m: 1, width: width || 300 }} size="small">
      <InputLabel id={label}>{label}</InputLabel>
      <Select labelId={label} value={value != null ? value : ''} renderValue={renderValue} multiple={multiple} onChange={handleChange} input={<OutlinedInput label={label} />} MenuProps={MENU_PROPS}>
        {values.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {multiple ? <Checkbox checked={value.indexOf(item.value) > -1} /> : ''}
            <ListItemText primary={item.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
